import React from "react";
import clsx from "clsx";

import { ActiveLearningInquiryEvaluationsByStudent } from "../../../../state";

import styles from "./InquiryEvaluationTable.module.scss";

type Props = {
  studentEvaluation: ActiveLearningInquiryEvaluationsByStudent;
  goToStudentResponse: () => void;
};

const InquiryEvaluationTable: React.FC<Props> = ({
  studentEvaluation,
  goToStudentResponse,
}) => {
  const evaluation = studentEvaluation.data?.[0]?.evaluation;

  return (
    <div className={styles.table}>
      <div className={styles.studentBlock}>
        {evaluation && !evaluation.is_read && (
          <span className={styles.new}>new!</span>
        )}
        <span className={styles.name} onClick={goToStudentResponse}>
          {studentEvaluation.student.full_name}
        </span>
      </div>
      <div className={styles.inquiryBlock}>
        <div className={styles.header}>問い</div>
        <div className={styles.inquiry}>
          {evaluation?.active_learning_inquiry ?? (
            <span className={styles.emptyMessage}>
              生徒がLesson03 / WORK02で回答した「問い」が入ります。
            </span>
          )}
        </div>
        <div className={styles.content}>
          <div className={clsx(styles.score, styles.total)}>
            <span className={styles.label}>合計スコア</span>
            <span className={styles.value}>
              <span className={styles.num}>{evaluation?.total_score ?? 0}</span>
              /<span className={styles.den}>9</span>
            </span>
          </div>
          <div className={styles.score}>
            <span className={styles.label}>内発性</span>
            <span className={styles.value}>
              <span className={styles.num}>
                {evaluation?.intrinsic_motivation_score ?? 0}
              </span>
              /<span className={styles.den}>3</span>
            </span>
          </div>
          <div className={styles.score}>
            <span className={styles.label}>思考の深さ</span>
            <span className={styles.value}>
              <span className={styles.num}>
                {evaluation?.thinking_depth_score ?? 0}
              </span>
              /<span className={styles.den}>3</span>
            </span>
          </div>
          <div className={styles.score}>
            <span className={styles.label}>具体性</span>
            <span className={styles.value}>
              <span className={styles.num}>
                {evaluation?.concreteness_score ?? 0}
              </span>
              /<span className={styles.den}>3</span>
            </span>
          </div>
        </div>
      </div>
      <div className={styles.instructionBlock}>
        <div className={styles.header}>指導例</div>
        <div className={styles.content}>
          {evaluation ? (
            <>
              <div className={styles.block}>
                <p className={styles.title}>【内発性】</p>
                <p className={styles.text}>
                  {evaluation.instructional_example_for_intrinsic_motivation}
                </p>
              </div>
              <div className={styles.block}>
                <p className={styles.title}>【思考の深さ】</p>
                <p className={styles.text}>
                  {evaluation.instructional_example_for_thinking_depth}
                </p>
              </div>
              <div className={styles.block}>
                <p className={styles.title}>【具体性】</p>
                <p className={styles.text}>
                  {evaluation.instructional_example_for_concreteness}
                </p>
              </div>
            </>
          ) : (
            <p className={styles.emptyMessage}>
              生徒がLesson01〜03を回答すると、スコア・指導例が生成されます。
            </p>
          )}
          <div className={styles.link} onClick={goToStudentResponse}>
            生徒の回答を見る{">>"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InquiryEvaluationTable;
